import React from 'react';

const Footer = () => {
    return (
         <footer className="footer">
            <div className="content-container">
                <a className="footer__title" href="https://www.jwortiz.dev/"><h1>Return to JWOrtiz.dev</h1></a>
            </div>
        </footer>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js